import type { GraphQLClientResponse } from "../client/types";
import type { Variables } from "../graphql";
import { execute, GraphQLError } from "../graphql";
import type { ExecuteOptimisticApiArgs } from "./types";

const resolverProxy = <TResolvers extends { [key: string | symbol]: unknown }>(
  resolvers: TResolvers,
): TResolvers =>
  new Proxy(resolvers, {
    get: function (target, name: keyof TResolvers) {
      return name in target
        ? target[name]
        : new GraphQLError(`${String(name)} resolver is not defined`);
    },
  });

export const executeOptimisticApi = async <
  TData,
  TVars extends Variables | undefined,
>({
  query,
  resolvers,
  variables,
  currentData,
  schema,
}: ExecuteOptimisticApiArgs<TData, TVars>): Promise<
  GraphQLClientResponse<TData>
> => {
  return execute({
    schema,
    query,
    resolvers: resolverProxy(resolvers),
    context: { currentData },
    variables,
  });
};
